/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

export default {
  updCartId (state, cartId) {
    state.cartId = cartId
    state.cartIdMask = cartId
  },
  updCartIdMask (state, cartIdMask) {
    state.cartIdMask = cartIdMask
  },
  updCartItems (state, { items, invalid = false }) {
    state.items = [...items]
  },
  updateMinicart (state, status) {
    state.updateMinicart = status
  },
  updPullItems (state, { items }) {
    state.pullItems = [...items]
  },
  updCart (state, cart) {
    state.total = cart
    // update cart items
    state.items = cart.items || []
    state.cartId = cart.cart_id
  },
  setGiftCardOnCart (state, hasGiftCard) {
    state.hasGiftCard = hasGiftCard
  },
  busySync: (state, status) => { state.busySync = status }
}
